var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("h3", { staticClass: "display-3" }, [
        _vm._v(_vm._s(_vm.title ? _vm.title : "Message Center")),
      ]),
      _vm._v(" "),
      _c("v-divider", { staticClass: "mt-2" }),
      _vm._v(" "),
      !_vm.isAuthed
        ? _c("span", { staticClass: "subheading" }, [
            _vm._v(
              "\n    Sorry, message center is not available without login.\n    "
            ),
            _c("br"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isAuthed
        ? _c(
            "v-card",
            { attrs: { loading: _vm.loading } },
            [
              _c(
                "v-card-text",
                [
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.messages,
                      pagination: _vm.options,
                      "total-items": _vm.totalMessageCount,
                      loading: _vm.loading,
                      "items-per-page": _vm.itemsPerPage,
                    },
                    on: {
                      "update:pagination": function ($event) {
                        _vm.options = $event
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "items",
                          fn: function (props) {
                            return [
                              _c("td", [_vm._v(_vm._s(props.item.Id))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.Title))]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        color: _vm.iconColor[props.item.Status],
                                      },
                                    },
                                    [
                                      _c("v-icon", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.statusIcons[props.item.Status]
                                            ) +
                                            "\n              "
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.statusText[props.item.Status]
                                              ? _vm.statusText[
                                                  props.item.Status
                                                ]
                                              : props.item.Status
                                          ) +
                                          "\n            "
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDateTime(
                                      props.item.CreateDateTime,
                                      {
                                        format:
                                          _vm.formats.prettyDateTimeFormat,
                                        excludeUtcText: true,
                                      }
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                _vm._l(props.item.Details, function (l) {
                                  return _c("ul", { key: l }, [
                                    _c("li", {
                                      domProps: { innerHTML: _vm._s(l) },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.navigateToFile.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    }),
                                  ])
                                }),
                                0
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1635310102
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-2",
                      staticStyle: { margin: "0" },
                      attrs: {
                        color: "primary",
                        large: "",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.getMessageData },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("refresh"),
                      ]),
                      _vm._v("Refresh\n      "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }